module.exports = __webpack_public_path__ + "static/media/9.ce2b829e.jpg";